<template>
  <div v-if="total > limit" class="intercom-pagination">
    <span class="pagination-info">
      Showing {{ rangeStart }}–{{ rangeEnd }} of {{ total }} {{ itemLabel }}
    </span>

    <div class="pagination-controls">
      <IntercomButton
        variant="secondary"
        size="sm"
        :disabled="offset === 0"
        @click="prev"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Prev
      </IntercomButton>

      <IntercomButton
        variant="secondary"
        size="sm"
        :disabled="!hasMore"
        @click="next"
      >
        Next
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </IntercomButton>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import IntercomButton from './IntercomButton.vue'

const props = defineProps({
  total: { type: Number, required: true },
  limit: { type: Number, default: 25 },
  offset: { type: Number, default: 0 },
  itemLabel: { type: String, default: 'items' },
})

const emit = defineEmits(['update:offset'])

const rangeStart = computed(() => props.offset + 1)
const rangeEnd = computed(() => Math.min(props.offset + props.limit, props.total))
const hasMore = computed(() => props.offset + props.limit < props.total)

const prev = () => {
  const newOffset = Math.max(0, props.offset - props.limit)
  emit('update:offset', newOffset)
}

const next = () => {
  if (hasMore.value) {
    emit('update:offset', props.offset + props.limit)
  }
}
</script>

<style scoped>
@import '@shared/styles/intercom-tokens.css';

.intercom-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-4);
  border-top: 1px solid var(--color-gray-200);
}

.pagination-info {
  font-size: var(--font-size-sm);
  color: var(--color-gray-500);
}

.pagination-controls {
  display: flex;
  gap: var(--space-2);
}

@media (max-width: 768px) {
  .intercom-pagination {
    flex-direction: column;
    gap: var(--space-3);
    text-align: center;
  }
}
</style>
